// NAV
var navbar = document.querySelector("#navbar");
var siteHeaderMenu = document.querySelectorAll(".navbar-nav");

// Hamburger menu icon
var hamburger = document.querySelector(".navbar-toggler");

// On click
hamburger.addEventListener("click", function (e) {
  e.stopPropagation(); // Stop event propagation

  hamburger.classList.toggle("is-active");

  if (hamburger.classList.contains("is-active")) {
    navbar.classList.add("show");
  } else {
    navbar.classList.remove("show");
  }
});

// Toggles the sub-menu when dropdown toggle button accessed
var dropdownToggles = document.querySelectorAll(".dropdown-toggle");
dropdownToggles.forEach(function (toggle) {
  toggle.addEventListener("click", function (e) {
    var dropdownMenu = this.nextElementSibling;

    if (this.previousElementSibling.getAttribute("href") !== "#") {
      this.classList.toggle("toggled-on");
      dropdownMenu.classList.toggle("toggled-on");

      dropdownMenu.setAttribute(
        "aria-hidden",
        dropdownMenu.getAttribute("aria-hidden") === "true" ? "false" : "true",
      );

      this.setAttribute(
        "aria-expanded",
        this.getAttribute("aria-expanded") === "false" ? "true" : "false",
      );
    }
  });
});

// Aria arvot hoverille
var subMenuParents = document.querySelectorAll(".sub-menu-parent");
subMenuParents.forEach(function (parent) {
  parent.addEventListener("mouseenter", function (e) {
    var dropdownMenu = this.querySelector(".dropdown-menu");
    dropdownMenu.setAttribute(
      "aria-hidden",
      dropdownMenu.getAttribute("aria-hidden") === "true" ? "false" : "true",
    );
  });
});

// jos päämenun linkillä  on linkkinä #, niin avataan pudotusvalikko klikattaessa
function menuWithTag() {
  var subMenuParents = document.querySelectorAll(".sub-menu-parent");
  subMenuParents.forEach(function (parent) {
    parent.addEventListener("click", function (e) {
      var navLink = this.querySelector(".nav-link");
      var dropdownToggle = this.querySelector(".dropdown-toggle");
      var dropdownMenu = this.querySelector(".dropdown-menu");

      if (navLink.getAttribute("href") === "#") {
        dropdownToggle.classList.toggle("toggled-on");
        dropdownMenu.classList.toggle("toggled-on");

        dropdownMenu.setAttribute(
          "aria-hidden",
          dropdownMenu.getAttribute("aria-hidden") === "true"
            ? "false"
            : "true",
        );

        dropdownToggle.setAttribute(
          "aria-expanded",
          dropdownToggle.getAttribute("aria-expanded") === "false"
            ? "true"
            : "false",
        );
      }
    });
  });

  var subMenuLinks = document.querySelectorAll(".sub-menu-parent > ul");
  subMenuLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  });
}

// jos sub menun linkillä  on linkkinä #, niin avataan pudotusvalikko klikattaessa
$(".sub-sub-menu-parent").on("click", function (e) {
  var $this = $(this);

  if ($this.children(".nav-link").attr("href") === "#") {
    $this.children(".dropdown-toggle").toggleClass("toggled-on");
    $this.children(".dropdown-menu").toggleClass("toggled-on");

    $(this)
      .children(".dropdown-menu")
      .attr(
        "aria-hidden",
        $(this).children(".dropdown-menu").attr("aria-hidden") === "true"
          ? "false"
          : "true",
      );

    $(this)
      .children(".dropdown-toggle")
      .attr(
        "aria-expanded",
        $(this).children(".dropdown-toggle").attr("aria-expanded") === "false"
          ? "true"
          : "false",
      );

    e.stopPropagation();
  }
});

function focusOut() {
  $(".sub-menu-parent .dropdown-menu").on("focusout", function () {
    setTimeout(function () {
      var is_in_menu = $(document.activeElement).closest(".toggled-on").length;

      if (!is_in_menu) {
        $(".dropdown-menu").removeClass("toggled-on");
        $(".dropdown-toggle").removeClass("toggled-on");
      }
    }, 10);
  });
}

// var eventFired = 0;

if ($(window).width() > 960) {
  focusOut();
}

// else {
//   eventFired = 1;
// }

// $(window).on('resize', function() {
//     if (!eventFired) {
//         if ($(window).width() > 960) {
//           focusOut();
//         } else {
//           hamburger.classList.remove('is-active');

//         }
//     }
// });
// console.log(eventFired);

// Keyboard navigation
document
  .querySelectorAll(".menu-item a, button.dropdown-toggle")
  .forEach(function (element) {
    element.addEventListener("keydown", function (event) {
      if (
        !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(
          event.code,
        )
      ) {
        return;
      }

      event.stopPropagation();

      switch (event.code) {
        case "ArrowLeft": // Left key
          if (this.classList.contains("dropdown-toggle")) {
            this.previousElementSibling.focus();
          } else {
            var prevSibling = this.parentNode.previousElementSibling;
            var dropdownToggle = prevSibling.querySelector(
              "button.dropdown-toggle",
            );
            if (dropdownToggle) {
              dropdownToggle.focus();
            } else {
              prevSibling.querySelector("a").focus();
            }
          }

          if (this.matches("ul ul ul.sub-menu.toggled-on li:first-child a")) {
            this.closest("ul.sub-menu.toggled-on")
              .previousElementSibling.querySelector("button.dropdown-toggle")
              .focus();
          }

          break;

        case "ArrowRight": // Right key
          if (this.nextElementSibling.matches("button.dropdown-toggle")) {
            this.nextElementSibling.focus();
          } else if (
            this.parentNode.nextElementSibling.querySelector("input")
          ) {
            this.parentNode.nextElementSibling.querySelector("input").focus();
          } else {
            this.parentNode.nextElementSibling.querySelector("a").focus();
          }

          if (this.matches("ul.sub-menu .dropdown-toggle.toggled-on")) {
            this.parentNode
              .querySelector("ul.sub-menu li:first-child a")
              .focus();
          }

          break;

        case "ArrowDown": // Down key
          if (this.nextElementSibling) {
            this.nextElementSibling.querySelector("li:first-child a").focus();
          } else if (
            this.parentNode.nextElementSibling.querySelector("input")
          ) {
            this.parentNode.nextElementSibling.querySelector("input").focus();
          } else {
            this.parentNode.nextElementSibling.querySelector("a").focus();
          }

          if (
            this.matches("ul.sub-menu a") &&
            this.nextElementSibling.matches("button.dropdown-toggle")
          ) {
            this.parentNode.nextElementSibling.querySelector("a").focus();
          }

          if (
            this.matches("ul.sub-menu .dropdown-toggle") &&
            this.parentNode.nextElementSibling.querySelector(".dropdown-toggle")
          ) {
            this.parentNode.nextElementSibling
              .querySelector(".dropdown-toggle")
              .focus();
          }

          break;

        case "ArrowUp": // Up key
          if (this.parentNode.previousElementSibling) {
            this.parentNode.previousElementSibling.querySelector("a").focus();
          } else {
            this.closest("ul")
              .previousElementSibling.querySelector(
                ".dropdown-toggle.toggled-on",
              )
              .focus();
          }

          if (
            this.matches("ul.sub-menu .dropdown-toggle") &&
            this.parentNode.previousElementSibling.querySelector(
              ".dropdown-toggle",
            )
          ) {
            this.parentNode.previousElementSibling
              .querySelector(".dropdown-toggle")
              .focus();
          }

          break;
      }
    });
  });

const menu = document.querySelector("#menu-paavalikko");
if (menu) {
  const menuItems = menu.querySelectorAll("li.highlight");

  // Create a new div element
  const newDiv = document.createElement("template");
  newDiv.classList.add("highlight-menu-items");

  // Loop through the menu items with the "highlight" class and append them to the new div
  menuItems.forEach((item) => {
    newDiv.appendChild(item);
  });

  // Add the new div to the menu as the last child element
  menu.appendChild(newDiv);
}

//
// Sivun Custom JS
//

// Pyörivät numerot

function isScrolledIntoView(elem) {
  var docViewTop = window.scrollY;
  var docViewBottom = docViewTop + window.innerHeight;

  var elemTop = elem.offsetTop;
  var elemBottom = elemTop + elem.offsetHeight;

  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

function testScroll() {
  var sykliNumeroina = document.querySelector(".sykli-numeroina");
  var scrlnumbers = document.querySelectorAll(".scrlnumber");

  if (sykliNumeroina && isScrolledIntoView(sykliNumeroina) && !viewed) {
    viewed = true;
    scrlnumbers.forEach(function (number) {
      var targetNumber = parseInt(number.textContent);
      var counter = 0;
      var duration = 2000;
      var start = null;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        var percentage = Math.min(progress / duration, 1);
        var currentNumber = Math.ceil(percentage * targetNumber);

        if (currentNumber >= 10000) {
          number.textContent = currentNumber.toLocaleString("fi-FI", {
            useGrouping: true,
          });
        } else {
          number.textContent = currentNumber;
        }

        if (progress < duration) {
          window.requestAnimationFrame(step);
        }
      }

      window.requestAnimationFrame(step);
    });
  }
}

window.addEventListener("scroll", testScroll);
var viewed = false;

// Koulutuskalenteri hakufilter
const filterForm = document.getElementById("filter");
if (filterForm) {
  const button = filterForm.querySelector("button");
  if (button) {
    filterForm.addEventListener("submit", async function (event) {
      event.preventDefault(); // Prevent form submission

      button.textContent = "Haetaan...";

      try {
        const response = await fetch(filterForm.getAttribute("action"), {
          method: filterForm.getAttribute("method"),
          body: new FormData(filterForm),
        });

        if (response.ok) {
          button.textContent = "Etsi kursseja";
          const coursesContainer = document.getElementById("eventilla-courses");
          if (coursesContainer) {
            coursesContainer.innerHTML = await response.text();
          }
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }

      button.textContent = "Etsi kursseja";
    });
  }
}

// Säädetään sivupalkin korkeutta, jos sivulla on iso pääkuva
sidebarWithHero = () => {
  const body = document.querySelector("body");
  const hero = document.body.querySelector(".site-banner");
  const sidebar = document.body.querySelector("#sidebar");

  if (hero && sidebar) {
    body.classList.add("page-has-hero-and-sidebar");
  }
};

// Jos hero kuvalla on valittu, että näytetään vain kuva eikä sisältöä, niin vaihdetaan h1:n ja ensimmäisen heron järjestystä
// const h1 = document.querySelector(".entry-title");
// const firstHero = document.querySelector(".hero.section-only-image");
// if (firstHero) {
//     firstHero.after(h1);
// }

// Siirretään footer menun viimeinen osio eri kohtaan - sekä kadenjalki.fi button
const footermenu = document.querySelector(".footer-main-menu");

if (footermenu) {
  const yhteysMenuitem = footermenu.querySelector(".menu-item-53");
  const kadenjalki = footermenu.querySelector(".highlight.external");
  const footerLastColumn = document.querySelector(".footerlastcol");
  const lista = document.createElement("ul");

  lista.classList.add("footer-yhteys-menu");
  lista.appendChild(kadenjalki);
  lista.appendChild(yhteysMenuitem);

  footerLastColumn.prepend(lista);
}

// remove loading lazy atribute from first banner images and hero slider images
removeLoadingLazy = () => {
  // First image on the page content
  const firstImageOnPage = document.querySelector(".hero .site-banner-bg img");
  firstImageOnPage.removeAttribute("loading");

  // Swiper slider images
  const swiperImages = document.querySelectorAll(".swiper .site-banner-bg img");
  swiperImages.forEach((image) => {
    image.removeAttribute("loading");
  });
};

// Get all the elements with class "henkilosto-kuvaus"
// const kuvausDivs = document.querySelectorAll(".henkilosto-kuvaus");
// const maxLength = 300;

// kuvausDivs.forEach(kuvausDiv => {
//   const kuvausText = kuvausDiv.innerHTML.trim();

//   if (kuvausText.length > maxLength) {
//     // Create a new div to hold the truncated text and "read more" link
//     const truncatedDiv = document.createElement("div");
//     truncatedDiv.classList.add("henkilosto-kuvaus");

//     // Create a new span to hold the truncated text and "..." characters
//     const pallurat = document.createElement("span");
//     pallurat.style.display = "inline";
//     pallurat.innerHTML = "...";
//     const truncatedSpan = document.createElement("span");
//     truncatedSpan.innerHTML = kuvausText.substring(0, maxLength);
//     truncatedSpan.appendChild(pallurat);

//     // Create a new span to hold the full text
//     const fullSpan = document.createElement("span");
//     fullSpan.innerHTML = kuvausText.substring(maxLength);
//     fullSpan.style.display = "none";

//     // Create a new "read more" link
//     const readMoreLink = document.createElement("a");
//     readMoreLink.href = "#";
//     readMoreLink.innerHTML = "Lue lisää";

//     // Add event listener to toggle the full text and "..." when the link is clicked
//     readMoreLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       fullSpan.style.display = fullSpan.style.display === "none" ? "inline" : "none";
//       pallurat.style.display = pallurat.style.display === "none" ? "inline" : "none"; // Toggle the pallurat element's display
//       readMoreLink.innerHTML = fullSpan.style.display === "none" ? "Lue lisää" : "Näytä vähemmän";
//     });

//     // Append the truncated text, full text and "read more" link to the new div
//     truncatedDiv.appendChild(truncatedSpan);
//     truncatedDiv.appendChild(fullSpan);
//     truncatedDiv.appendChild(readMoreLink);

//     // Replace the original div with the new div
//     kuvausDiv.parentNode.replaceChild(truncatedDiv, kuvausDiv);
//   }
// });

// Wait for the page to load before attaching event listeners
document.addEventListener("DOMContentLoaded", function () {
  // Get all the filter options
  const filters = document.querySelectorAll("#henkilosto-filter li");

  // Attach a click event listener to each filter option
  filters.forEach(function (filter) {
    filter.addEventListener("click", function () {
      // If "All" is selected, show all the elements
      if (filter.classList.contains("all")) {
        document.querySelectorAll(".col-md-6").forEach(function (element) {
          element.style.display = "block";
        });
      } else {
        // Otherwise, hide the elements that do not match the selected filter
        const selectedFilter = filter.classList[0];
        document.querySelectorAll(".col-md-6").forEach(function (element) {
          if (!element.classList.contains(selectedFilter)) {
            element.style.display = "none";
          } else {
            element.style.display = "block";
          }
        });
      }

      // Remove the "active" class from all filter options
      filters.forEach(function (filter) {
        filter.classList.remove("active");
      });

      // Add the "active" class to the selected filter option
      filter.classList.add("active");
    });
  });
});

let debounceTimeout;
let body = document.querySelector("body");
let scrollingElement = document.scrollingElement;

setScrollClass();

window.addEventListener("scroll", setScrollClass);
window.addEventListener("resize", setScrollClass);

function setScrollClass() {
  if (debounceTimeout) {
    window.cancelAnimationFrame(debounceTimeout);
  }

  debounceTimeout = window.requestAnimationFrame(function () {
    let scrollTop = scrollingElement.scrollTop;
    let scrollHeight = scrollingElement.scrollHeight;
    let innerHeight = window.innerHeight;
    let scrollBottom = scrollHeight - innerHeight - scrollTop;

    body.classList.toggle("at-top", scrollTop < 380);
    // body.classList.toggle('at-bottom', scrollBottom < 48);
  });
}

// Sidebar buttons for child pages
$("#sidebar .page_item_has_children").prepend(
  '<button class="sidebar-button sub-menu-button"><span class="visuallyhidden">Avaa sivupalkin menu</span></button>',
);

$(document).on("click", ".sidebar-button", function (e) {
  $(this)
    .siblings(".children")
    .stop()
    .slideToggle(200, function () {
      if ($(this).is(":visible")) {
        $(this).css("display", "block");
      }
    });
  $(this).toggleClass("open");
});

if ($("#sidebar .page_item_has_children").hasClass("current_page_item")) {
  $("#sidebar .page_item_has_children.current_page_item")
    .children(".sub-menu-button")
    .addClass("open");
  $("#sidebar .page_item_has_children.current_page_item")
    .children(".children")
    .css("display", "block");
}
if ($("#sidebar .page_item_has_children").hasClass("current_page_ancestor")) {
  $("#sidebar .page_item_has_children.current_page_ancestor")
    .children(".sub-menu-button")
    .addClass("open");
  $("#sidebar .page_item_has_children.current_page_ancestor")
    .children(".children")
    .css("display", "block");
}

//
// Fixed header
//

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("#header");

  if (!header) {
    return;
  }

  // Paikkamerkki estää sisältöä hyppäämästä,
  // kun header poistuu normaalista dokumenttivirrasta.
  const placeholder = document.createElement("div");
  placeholder.classList.add("header-placeholder");
  placeholder.setAttribute("aria-hidden", "true");

  header.parentNode.insertBefore(placeholder, header);

  let headerOffsetTop = 0;
  let ticking = false;

  function getAdminBarHeight() {
    const adminBar = document.querySelector("#wpadminbar");

    return adminBar ? adminBar.offsetHeight : 0;
  }

  function updateMeasurements() {
    // Mittaa sijainti ilman fixed-tilaa.
    header.classList.remove("is-fixed");
    placeholder.classList.remove("is-active");

    headerOffsetTop = header.getBoundingClientRect().top + window.scrollY;

    placeholder.style.height = `${header.offsetHeight}px`;

    document.documentElement.style.setProperty(
      "--header-fixed-top",
      `${getAdminBarHeight()}px`,
    );

    updateHeader();
  }

  function updateHeader() {
    const adminBarHeight = getAdminBarHeight();
    const shouldBeFixed = window.scrollY + adminBarHeight >= headerOffsetTop;

    header.classList.toggle("is-fixed", shouldBeFixed);
    placeholder.classList.toggle("is-active", shouldBeFixed);

    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  window.addEventListener("scroll", handleScroll, {
    passive: true,
  });

  window.addEventListener("resize", updateMeasurements);

  updateMeasurements();
});

//
// Run functions

sidebarWithHero();
menuWithTag();
